import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;